// @ts-ignore
import {defineStore} from 'pinia';
// @ts-ignore
import {ref, computed, watch} from 'vue';
// @ts-ignore
import {assert, date} from 'superstruct'
// @ts-ignore
import {SearchStoreStruct} from "../superstruct/intersport-structs.ts";
// @ts-ignore
import { ISOStringToDate, dateToISOString } from "@elements/date-utils";
// @ts-ignore
import {find, addClass, removeClass} from "@elements/dom-utils";
// @ts-ignore
import Popover from "bootstrap/js/dist/popover";
// @ts-ignore
import Modal from "bootstrap/js/dist/modal";
// @ts-ignore
import {DateRange, Location, SearchStore, SelectOptions} from "../types/intersport.ts";
// @ts-ignore
import {useProductsStore} from "./ProductStore.ts";
// @ts-ignore
import {usePeopleStore} from "./PeopleStore.ts";
// @ts-ignore
import {translate} from "@elements/translations";
// @ts-ignore
import {deepCopy} from "../utils/utils.ts";

export const useSearchStore = defineStore('SearchStore', () => {

    const selectedLocation = ref({});
    const locations = ref([]);
    const startDate = ref('');
    const endDate = ref('');
    const generalMinDate = ref('');
    const generalMaxDate = ref('');
    const minDate = ref('');
    const maxDate = ref('');
    const disabledDates = ref([]);
    const errors = ref([]);

    let selectedDateRangeIndex: number = 0;
    let productStore = useProductsStore();
    let peopleStore = usePeopleStore();

    function fillStore(data: SearchStore) {
        try {
            assert(data, SearchStoreStruct);

            locations.value = data.locations;
            startDate.value = data.startDate;
            endDate.value = data.endDate;
            if (data.selectedLocation) {
                selectedLocation.value = data.selectedLocation;

                if (startDate.value !== '' && endDate.value !== '') {
                    searchProducts();
                    peopleStore.reloadPeople();
                }
            }
        } catch (error: any) {
            errors.value.push(error.message);
        }
    }

    function setLocation(id: string, resetDates: boolean = true) {
        selectedLocation.value = locations.value.filter((location: Location) => location.value === id)[0];

        generalMinDate.value = getSmallerDate(selectedLocation.value.dateRanges[0].startDate, dateToISOString(new Date()));
        generalMaxDate.value = selectedLocation.value.dateRanges[selectedLocation.value.dateRanges.length - 1].endDate;

        if (resetDates) {
            startDate.value = '';
            endDate.value = '';
        }

        for (let i = 0; i < selectedLocation.value.dateRanges.length - 1; i++) {
            let dateRange = selectedLocation.value.dateRanges[i];
            if (selectedLocation.value.dateRanges.length > 1) {
                const range = getDisabledDates(dateRange.endDate, selectedLocation.value.dateRanges[i + 1].startDate);

                if (!disabledDates.value.some(disabledDate => disabledDate.from === range.from && disabledDate.to === range.to)) {
                    disabledDates.value.push(range);
                }
            }
        }
    }

    function getLocations() {
        let returnArray: SelectOptions = [
            {
                value: '',
                label: translate('intersport.location-select-placeholder'),
                disabled: true
            }
        ];
        returnArray = [...returnArray, ...deepCopy(locations.value)];

        return returnArray;
    }

    function getSmallerDate(date1: string, date2: string) {
        let date1Obj = ISOStringToDate(date1);
        let date2Obj = ISOStringToDate(date2);
        return date1Obj < date2Obj ? date1 : date2;
    }

    function getDisabledDates(startDate: string, stopDate: string) {
        let start = ISOStringToDate(startDate);
        start.setDate(start.getDate() + 1)
        let end = ISOStringToDate(stopDate);
        end.setDate(end.getDate() - 1)
        return {
            from: dateToISOString(start),
            to: dateToISOString(end)
        };
    }

    async function searchProducts(modal: HTMLElement = undefined) {
        await productStore.getProductsForLocationAndDate(selectedLocation.value.id, startDate.value, endDate.value);
        let sidebox = find('.js-popover-interpsort--third');
        let thirdPopover = Popover.getOrCreateInstance(sidebox);

        if (productStore.getSelectedAvailabilities().length === 0) {
            togglePopover(thirdPopover, true);
        }
        removeClass('disabled', sidebox);

        if (modal) {
            let modalInstance = Modal.getOrCreateInstance(modal);
            modalInstance.hide();
        }
    }

    function togglePopover(popover: Popover, show: boolean) {
        popover.enable();
        if (show) {
            popover.show();
        } else {
            popover.hide();
        }
        popover.disable();
    }

    watch(startDate, (newValue: string) => {
        if (newValue && Object.keys(selectedLocation.value).length > 0) {
            startDate.value = newValue;
            minDate.value = newValue;

            let tmpArr = [... selectedLocation.value.dateRanges];
            tmpArr.sort((a: DateRange, b: DateRange) => {
                let distanceA = Math.abs(ISOStringToDate(a.startDate) - ISOStringToDate(startDate.value));
                let distanceB = Math.abs(ISOStringToDate(b.startDate) - ISOStringToDate(startDate.value));
                return distanceA - distanceB;
            });

            // Was this before:
            // maxDate.value = tmpArr[0].endDate;
            // Set max date to 14 days after start date because the IS-Rent API only allows 14 days and otherwise throws an error
            let tmpEndDate = ISOStringToDate(startDate.value);
            tmpEndDate.setDate(tmpEndDate.getDate() + 13);
            maxDate.value = dateToISOString(tmpEndDate);

            let newDateRangeIndex = selectedLocation.value.dateRanges.findIndex((dateRange: DateRange) => dateRange.startDate === tmpArr[0].startDate && dateRange.endDate === tmpArr[0].endDate);
            if (newDateRangeIndex !== selectedDateRangeIndex) {
                selectedDateRangeIndex = newDateRangeIndex;
                endDate.value = '';
            }
        }
    }, {deep: true});

    watch(endDate, (newValue: string) => {
        let sidebox = find('.js-popover-interpsort--third');
        let secondPopover = Popover.getOrCreateInstance(find('.js-popover-interpsort--second'));
        let thirdPopover = Popover.getOrCreateInstance(sidebox);

        if (newValue && selectedLocation.value && startDate.value) {
            togglePopover(secondPopover, false);
        } else {
            togglePopover(secondPopover, true);
            togglePopover(thirdPopover, false);
            if (productStore.getSelectedAvailabilities().length === 0) {
                addClass('disabled', sidebox);
            }
        }
    }, {deep: true})

    watch(selectedLocation, (newValue: Location, oldValue: Location) => {
        if (Object.keys(oldValue).length <= 0 && Object.keys(newValue).length > 0) {
            setLocation(newValue.id, false);

            let firstPopover = Popover.getOrCreateInstance(find('.js-popover-interpsort--first'));
            togglePopover(firstPopover, false);
        }
    })

    return {
        selectedLocation,
        locations,
        startDate,
        endDate,
        generalMinDate,
        generalMaxDate,
        minDate,
        maxDate,
        disabledDates,
        errors,
        fillStore,
        setLocation,
        getLocations,
        searchProducts
    }
});